import React from 'react';

export default function TermsOfUse() {
  return (
    <>
      <section className="page-hero">
        <div className="container">
          <h1>Terms of Use</h1>
          <p>Last updated: March 26, 2026</p>
        </div>
      </section>

      <section className="legal-content">
        <div className="container">
          <p>
            Please read these Terms of Use ("Terms") carefully before using the Floor Plan Designer
            mobile application ("App") operated by Floor Plan Designer ("we", "our", or "us").
            By downloading, installing, or using the App, you agree to be bound by these Terms.
          </p>

          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing or using the App, you agree to comply with and be bound by these Terms
            and our Privacy Policy. If you do not agree to these Terms, you must not use the App.
          </p>

          <h2>2. License to Use</h2>
          <p>
            We grant you a limited, non-exclusive, non-transferable, revocable license to use the
            App for personal and non-commercial purposes, subject to these Terms. You may:
          </p>
          <ul>
            <li>Download and install the App on your personal device</li>
            <li>Create, edit, save, and export floor plan designs</li>
            <li>Use the built-in tools (calculator, level, ruler, etc.) for personal projects</li>
          </ul>

          <h2>3. Restrictions</h2>
          <p>You agree not to:</p>
          <ul>
            <li>Copy, modify, distribute, sell, or lease any part of the App</li>
            <li>Reverse engineer, decompile, or disassemble the App</li>
            <li>Remove any copyright, trademark, or proprietary notices from the App</li>
            <li>Use the App for any illegal or unauthorized purpose</li>
            <li>Attempt to gain unauthorized access to the App's systems or networks</li>
            <li>Use automated systems (bots, scrapers) to access the App</li>
            <li>Interfere with or disrupt the App's functionality</li>
          </ul>

          <h2>4. User Content</h2>
          <p>
            You retain ownership of all floor plans, designs, and content you create using the App
            ("User Content"). You are solely responsible for your User Content. By using the App,
            you represent that:
          </p>
          <ul>
            <li>You have the right to create and use your User Content</li>
            <li>Your User Content does not infringe any third-party rights</li>
            <li>Your User Content complies with applicable laws and regulations</li>
          </ul>

          <h2>5. Intellectual Property</h2>
          <p>
            The App, including its design, features, code, graphics, icons, and content, is owned
            by Floor Plan Designer and is protected by intellectual property laws. All rights not
            expressly granted in these Terms are reserved.
          </p>

          <h2>6. Third-Party Services</h2>
          <p>
            The App may integrate with third-party services (e.g., Google AdMob, Firebase). Your
            use of these services is subject to their respective terms and privacy policies. We are
            not responsible for the practices of third-party service providers.
          </p>

          <h2>7. Advertisements</h2>
          <p>
            The App may display advertisements provided by third-party ad networks. These ads may
            be targeted based on information collected as described in our Privacy Policy. The
            presence of ads does not constitute an endorsement of the advertised products or services.
          </p>

          <h2>8. Disclaimer of Warranties</h2>
          <p>
            The App is provided "AS IS" and "AS AVAILABLE" without warranties of any kind, whether
            express or implied. We do not warrant that:
          </p>
          <ul>
            <li>The App will be uninterrupted, secure, or error-free</li>
            <li>Measurements, calculations, or designs will be 100% accurate</li>
            <li>The App will meet your specific requirements</li>
            <li>Any defects will be corrected</li>
          </ul>
          <p>
            <strong>Important:</strong> Floor plans and measurements generated by the App are
            intended for reference and planning purposes only. They should not be used as a
            substitute for professional architectural or engineering drawings. Always consult
            a qualified professional for construction and building projects.
          </p>

          <h2>9. Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by applicable law, Floor Plan Designer shall not be
            liable for any indirect, incidental, special, consequential, or punitive damages,
            including but not limited to loss of data, profits, or business opportunities, arising
            from your use of or inability to use the App.
          </p>

          <h2>10. Indemnification</h2>
          <p>
            You agree to indemnify and hold harmless Floor Plan Designer, its affiliates, and their
            respective officers, directors, employees, and agents from any claims, damages, losses,
            or expenses arising from your use of the App or violation of these Terms.
          </p>

          <h2>11. Modifications to the App</h2>
          <p>
            We reserve the right to modify, suspend, or discontinue the App (or any part thereof)
            at any time with or without notice. We shall not be liable to you or any third party
            for any modification, suspension, or discontinuation.
          </p>

          <h2>12. Changes to Terms</h2>
          <p>
            We may revise these Terms at any time by posting the updated version within the App
            and on this page. The "Last updated" date will be revised accordingly. Your continued
            use of the App after changes constitutes acceptance of the revised Terms.
          </p>

          <h2>13. Governing Law</h2>
          <p>
            These Terms shall be governed by and construed in accordance with the laws of the
            jurisdiction in which Floor Plan Designer operates, without regard to conflict of
            law provisions.
          </p>

          <h2>14. Severability</h2>
          <p>
            If any provision of these Terms is found to be unenforceable or invalid, that provision
            shall be limited or eliminated to the minimum extent necessary, and the remaining
            provisions shall remain in full force and effect.
          </p>

          <h2>15. Contact Us</h2>
          <p>
            If you have questions about these Terms, please contact us at:
          </p>
          <ul>
            <li>Email: <a href="mailto:support@floorplandesigner.app">support@floorplandesigner.app</a></li>
            <li>Website: <a href="/contact">Contact Us</a></li>
          </ul>
        </div>
      </section>
    </>
  );
}
